// Shadows
export var textShadow1 = "text-shadow: 0 2px 4px rgba(0,0,0,0.77);"; // NORMAL
export default {
    textShadow1: textShadow1
};
